<template>
    <div>
        <Card shadow>
            <Row :gutter="18">
                <Col span="2">
                    <Button type="primary" @click.native="showModel">管理查询项</Button>
                </Col>
                <Col span="3">
                    <Button type="primary" @click.native="searchData()" :loading="loading">查询</Button>
                </Col>
                <Col span="19" style="text-align: right">
                    <Button type="primary" @click.native="eleToExcel()" style="margin-right: 12px">导出excel</Button>
                    <Button type="primary" @click.native="eleToPdf()">导出pdf</Button>
                </Col>
            </Row>
        </Card>
        <Table border :columns="table.columns" :data="table.data" style="margin-top: 12px" ref="tableRef"></Table>
        <Modal v-model="dataModel.show" width="950">
            <div slot="header">查询项管理</div>
            <Row :gutter="8" style="margin-bottom: 10px">
                <Col span="24" style="text-align: right">
                    <Button type="primary" @click.native="addData">新增查询项</Button>
                </Col>
            </Row>
            <template v-for="(item, index) in dataModel.modelData">
                <Form :model="item" :label-width="90" :key="index">
                    <Row :key="index" :gutter="18">
                        <Col span="4">
                            <Select placeholder="筛选盘口" filterable v-model="item.app_id" @on-change="updateSelect(item)">
                                <Option v-for="(temp, index) in app_list" :value="temp.appid" :key="index" :label="temp.appName">
                                    {{ temp.appName }}
                                    <span style="color: #bbb">（{{ temp.appid }}）</span>
                                </Option>
                            </Select>
                        </Col>
                        <Col span="4">
                            <Select placeholder="筛选 商户" filterable v-model="item.general_id" @on-change="updateGeneral(item)">
                                <Option v-for="(temp, index) in item.general_list" :value="temp.general" :key="index" :label="temp.general_name">
                                    {{ temp.general_name }}
                                    <span style="color: #bbb">（{{ temp.general }}）</span>
                                </Option>
                            </Select>
                        </Col>
                        <Col span="4">
                            <Select
                                placeholder="筛选 子商户
"
                                filterable
                                clearable
                                v-model="item.pack_no"
                            >
                                <Option v-for="(temp, index) in getCheckPackList(item)" :value="temp.pack_no" :key="index" :label="temp.pack_name">
                                    {{ temp.pack_name }}
                                    <span style="color: #bbb">（{{ temp.pack_no }}）</span>
                                </Option>
                            </Select>
                        </Col>
                        <Col span="10">
                            <FormItem label="推广时间范围">
                                <DatePicker type="daterange" format="yyyy-MM-dd" v-model="item.dateTime" placeholder="选择日期" :clearable="false" @on-change="changeDate(item)" :options="getDateOptions()" style="width: 270px !important"></DatePicker>
                            </FormItem>
                        </Col>
                        <!-- <Col span="5">
                            <FormItem label="推广结束">
                                <DatePicker
                                    type="date"
                                    format="yyyy-MM-dd"
                                    v-model="item.etime"
                                    placeholder="选择日期"
                                    :options="getDateOptions(new Date(item.stime).getTime())"
                                    :clearable="false"
                                ></DatePicker>
                            </FormItem>
                        </Col>-->
                        <Col span="2" style="text-align: right">
                            <Button type="error" @click.native="deleteData(index)">删除</Button>
                        </Col>
                    </Row>
                </Form>
            </template>
            <div slot="footer">
                <Button type="primary" @click.native="saveConfig">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import SingleReportHeader from './components/single_report_header.vue'
import { TransTopReq, GetCustomePage, UpdateCustomePage } from '@/api/admin/risk'
import moment from 'moment'
import { GetToken } from '@/libs/util'
export default {
    name: 'HandicapGameData',
    components: { SingleReportHeader },
    data() {
        return {
            all: {},
            promList: [],
            TransTopReqTimer: null,
            loading: false,
            isInit: false,
            isLoading: false,
            timestamp: 0,
            dataModel: {
                show: false,
                modelData: [],
                delData: []
            },
            table: {
                data: [],
                yData: {},
                columns: [
                    // { type: "index", title: "序号", align: "center", width: 60 },
                    {
                        key: 'start_time',
                        width: 110,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '开始日期', '显示推广开始日期')
                    },
                    {
                        key: 'app_name',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '盘口', '显示盘口名称')
                    },
                    {
                        key: 'pack_name',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '推广子商户', '推广子商户')
                    },
                    {
                        key: 'his_pay_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '盘口历史转入人数', '显示盘口历史转入人数')
                    },
                    {
                        key: 'pack_range_pay_num',
                        minWidth: 80,
                        align: 'center',
                        render: (h, params) => h('span', this.getCustomFixed(params.row.pack_range_pay_num)),
                        renderHeader: (h) => this.renderHeader(h, '推广期子商户转入人数', '显示推广子商户转入人数')
                    },
                    {
                        key: 'pack_range_pay_sum',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '推广期子商户转入金额', '显示推广期子商户转入金额'),
                        render: (h, params) => h('span', this.getCustomFixed(params.row.pack_range_pay_sum / 10000))
                    },
                    {
                        key: 'pack_new_user_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '当天子商户新增人数', '显示当天子商户新增人数')
                    },
                    {
                        key: 'pack_fist_pay_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '当天子商户首充人数', '显示当天子商户首充人数')
                    },
                    {
                        key: 'pack_pay_sum',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '当天子商户转入金额', '显示当天子商户转入金额'),
                        render: (h, params) => h('span', this.getCustomFixed(params.row.pack_pay_sum / 10000))
                    },
                    {
                        key: 'pay_user_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '当天盘口转入人数', '显示当天盘口转入人数')
                    },
                    {
                        key: 'active_user_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '当天盘口活跃人数', '显示当天盘口活跃人数')
                    },
                    {
                        key: 'bet_user_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '当天盘口投注人数', '显示当天盘口投注人数')
                    },
                    {
                        key: 'pay_bet_user_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '当天盘口充投人数', '显示当天盘口充投人数')
                    },
                    {
                        key: 'end_time',
                        width: 110,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '结束日期', '显示推广结束日期')
                    }
                ]
            }
        }
    },
    methods: {
        //查询数据
        searchData() {
            let httpList = []
            let loadingArr = []
            this.timestamp = new Date().getTime()
            for (let i in this.promList) {
                let item = this.promList[i]
                let app_id = item.app_id
                let app = this.app_list.find((el) => el.appid == app_id)
                let pack_no = item.pack_no
                let pack_name = ''
                let general = item.general_id
                if (pack_no === 0 || pack_no > 0) {
                    pack_name = item.pack_list.find((el) => el.pack_no == item.pack_no).pack_name
                } else {
                    pack_name = item.general_list.find((el) => el.general == general).general_name
                }
                let platid = app.platform
                let app_name = app.appName
                let params = this.getTransTopParams('GetAppPackList2', {
                    app_id,
                    platid,
                    app_name,
                    pack_name,
                    stime: this.getSecond(item.dateTime[0]),
                    etime: this.getSecond(item.dateTime[1], false),
                    page: 1,
                    limit: 10000,
                    sort: 0,
                    general,
                    pack_no,
                    timestamp: this.timestamp
                })
                if (pack_no === 0 || pack_no > 0) {
                    Object.assign({
                        list: [{ pack_no }]
                    })
                }
                httpList.push(params)
                loadingArr.push(1)
            }
            this.table.data = []
            if (httpList.length > 0) {
                let max = Math.min(5, httpList.length)
                for (let i = 0; i < max; i++) {
                    this.toHttp(httpList, loadingArr)
                }
            }
        },
        async toHttp(httpList, loadingArr) {
            if (httpList.length > 0) {
                this.openTimer()
                let params = httpList.shift()
                let res = await TransTopReq(params)
                let from = res._param.list ? res._param.list[0] : res._param
                let data = {
                    pack_range_pay_num: from.pay_num,
                    pack_range_pay_sum: from.pay_sum
                }

                let params1 = this.copyData(params)
                params1.param._param.stime = params1.param._param.etime - 24 * 60 * 60 + 1
                let res1 = await TransTopReq(params1)
                let from1 = res1._param.list ? res1._param.list[0] : res1._param
                let data1 = {
                    pack_fist_pay_sum: from1.fist_pay_sum,
                    pack_fist_pay_num: from1.fist_pay_num,
                    pack_pay_num: from1.pay_num,
                    pack_pay_sum: from1.pay_sum,
                    pack_new_user_num: from1.new_user_num
                }

                let params2 = this.copyData(params1)
                params2.param._func = 'GetNewPlatfromData'
                params2.param._param.general = -1
                params2.param._param.pack_no = -1
                let res2 = await TransTopReq(params2)
                let from2 = res2._param.data[0]
                let { pay_user_num, active_user_num, bet_user_num, pay_bet_user_num } = from2
                let data2 = {
                    pay_user_num,
                    active_user_num,
                    bet_user_num,
                    pay_bet_user_num
                }

                let params3 = this.copyData(params2)
                params3.param._func = 'GetNewPlatfromHisterData'
                TransTopReq(params3).then((res3) => {
                    if (params.timestamp == this.timestamp) {
                        loadingArr.shift()
                        let historyData = {}
                        for (let key in res3._param) {
                            historyData[`his_${key}`] = res3._param[key]
                        }
                        let result = Object.assign({}, data, data1, data2, historyData)
                        result.app_name = params.app_name
                        result.pack_name = params.pack_name
                        result.start_time = moment(params.param._param.stime * 1000)
                            .locale('zh-cn')
                            .format('YYYY/MM/DD')
                        result.end_time = moment(params.param._param.etime * 1000)
                            .locale('zh-cn')
                            .format('YYYY/MM/DD')
                        let tableData = [...this.table.data, result]
                        this.table.data = tableData
                        if (httpList.length > 0) {
                            this.toHttp(httpList, loadingArr)
                        }
                        if (loadingArr.length == 0) {
                            this.closeTimer()
                        }
                    }
                })
            }
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: param.platid,
                app_id: param.app_id,
                app_name: param.app_name,
                pack_name: param.pack_name,
                timestamp: param.timestamp,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: {
                        ...param
                    }
                }
            }
        },
        getCompColor(val) {
            return val > 0 ? 'red' : val < 0 ? '#32CD32' : 'black'
        },
        showModel() {
            this.dataModel.show = true
            let result = this.copyData(this.promList)
            for (let i = 0; i < result.length; i++) {
                let item = result[i]
                item.dateTime = [new Date(item.dateTime[0]), new Date(item.dateTime[1])]
            }
            this.dataModel.modelData = result
        },
        closeModel() {
            this.dataModel.show = false
        },
        saveConfig() {
            let result = true
            for (let i in this.dataModel.modelData) {
                let item = this.dataModel.modelData[i]
                result = result && item.general_id !== undefined && item.general_id > -1
                if (!result) break
            }
            if (result) {
                let json = this.copyData(this.dataModel.modelData)
                json.forEach((item) => {
                    delete item.general_list
                    delete item.pack_list
                })
                UpdateCustomePage({
                    uid: GetToken().uid,
                    path: 'HandicapPromotionData',
                    custome: JSON.stringify(json)
                }).then((res) => {
                    this.promList = this.copyData(this.dataModel.modelData)
                    this.closeModel()
                    this.searchData()
                })
            } else {
                this.$Message.info('请选择有效的商户和子商户')
            }
        },
        addData() {
            let app_id = this.app_list[0]['appid']
            let item = {
                app_id,
                general_id: -1,
                pack_no: -1,
                dateTime: [this.getCurrentZeroDay(), this.getCurrentZeroDay()],
                general_list: [],
                pack_list: []
            }
            this.dataModel.modelData.push(item)
            this.updateSelect(item)
        },
        getDateOptions(time) {
            let start = new Date(time).getTime()
            return {
                disabledDate: (val) => {
                    let date = new Date(val).getTime()
                    return date > new Date(moment(new Date()).format('YYYY-MM-DD')).getTime() + 1000 * 60 * 60 * 24 || date < new Date(moment(new Date()).format('YYYY-MM-DD')).getTime() - 45 * 24 * 60 * 60 * 1000
                }
            }
        },
        updateSelect(item) {
            let app_id = item.app_id
            let app = this.app_list.find((el) => el.appid == app_id)
            let platid = app.platform
            item.platid = platid
            let params = this.getTransTopParams('GetAppGeneralList', { app_id, platid, stime: 0, etime: 0, page: 1, limit: 10000, sort: 0, general: -1, pack_no: -1 })
            item.general_list = []
            item.general_id = -1
            item.pack_list = []
            item.pack_no = -1
            TransTopReq(params).then((res) => {
                item.general_list = res._param.general_list
                item.general_id = item.general_list[0] ? item.general_list[0].general : 0
                let params1 = this.copyData(params)
                params1.param._func = 'GetPackList'
                TransTopReq(params1).then((res) => {
                    item.pack_list = res._param.pack_list
                    this.updateGeneral(item)
                    this.$forceUpdate()
                })
            })
        },
        updateGeneral(item) {
            let list = item.pack_list.filter((el) => item.general_id == el.general)
            // item.pack_no = list[0] ? list[0]["pack_no"] : -1;
        },
        getCheckPackList(item) {
            return item.pack_list.filter((el) => item.general_id == el.general)
        },
        deleteData(index) {
            this.$Modal.confirm({
                title: '删除',
                content: '<p>是否确认删除该项配置</p>',
                onOk: () => {
                    let item = this.dataModel.modelData.splice(index, 1)[0]
                }
            })
        },
        changeDate(item) {
            if (item.dateTime[1].getTime() - item.dateTime[0].getTime() > 6 * 24 * 60 * 60 * 1000) {
                this.$Message.error('只能选择七天数据，请重新选择时间')
                item.dateTime = [this.getCurrentZeroDay(), this.getCurrentZeroDay()]
            } else {
                item.dateTime = [new Date(item.dateTime[0].setHours(0, 0, 0, 0)), new Date(item.dateTime[1].setHours(0, 0, 0, 0))]
            }
        },
        getCustomPage() {
            GetCustomePage({
                uid: GetToken().uid,
                path: 'HandicapPromotionData'
            }).then((res) => {
                let list = []
                if (res._param.custome) {
                    list = JSON.parse(res._param.custome)
                }
                this.promList = list
                let callList = []
                let httpList = []
                let result = []
                for (let i = 0; i < list.length; i++) {
                    let item = list[i]
                    callList.push(1)
                    httpList.push(item)
                }
                for (let i = 0; i < 8; i++) {
                    this.TransTopReq(httpList, result, callList)
                }
            })
        },
        TransTopReq(httpList, list, callList) {
            if (httpList.length > 0) {
                let item = httpList.shift()
                let result1 = false
                let result = false
                let app_id = item.app_id
                let platid = item.platid
                item.general_list = []
                item.pack_list = []
                let params = this.getTransTopParams('GetAppGeneralList', {
                    app_id,
                    platid,
                    stime: this.getSecond(item.dateTime[0]),
                    etime: this.getSecond(item.dateTime[1], false),
                    page: 1,
                    limit: 10000,
                    sort: 0,
                    general: -1,
                    pack_no: -1
                })
                let params1 = this.copyData(params)
                params1.param._func = 'GetPackList'
                params1.param._param.general = item.general_id
                TransTopReq(params1).then((res) => {
                    item.pack_list = res._param.pack_list || []
                    result1 = true
                    if (result && result1) {
                        list.push(item)
                        callList.shift()
                        this.TransTopReq(httpList, list, callList)
                        if (callList.length == 0) {
                            this.promList = list
                            this.searchData()
                        }
                    }
                })
                TransTopReq(params).then((res) => {
                    result = true
                    item.general_list = res._param.general_list || []
                    if (result && result1) {
                        list.push(item)
                        callList.shift()
                        this.TransTopReq(httpList, list, callList)
                        if (callList.length == 0) {
                            this.promList = list
                            this.searchData()
                        }
                    }
                })
            }
        },
        async initFunc() {
            this.isLoading = true
            this.getCustomPage()
        },
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 6000)
        }
    },
    created() {
        this.initFunc()
    }
}
</script>

<style scoped lang="less"></style>
